export var CHANGE_PROJECT_DEVICE_FRAME = 'CHANGE_DEVICE_FRAME';
export var CHANGE_PROJECT_DEVICE_COLOR = 'CHANGE_DEVICE_COLOR';
export var CHANGE_PROJECT_DEVICE_ORIENTATION = 'CHANGE_PROJECT_DEVICE_ORIENTATION';
export var CHANGE_DEVICE_ORIENTATION = 'CHANGE_DEVICE_ORIENTATION';
export var CHANGE_DEVICE_DETECTION = 'CHANGE_DEVICE_DETECTION';
